import { TrashIcon } from '@radix-ui/react-icons';
import { Button } from '@radix-ui/themes';
import { ImageConfig } from 'konva/lib/shapes/Image';
import { useState } from 'react';
import { Group, Image, KonvaNodeEvents, Rect } from 'react-konva';
import { Html } from 'react-konva-utils';
import useImage from 'use-image';

export function SkuImage({
  imgSrc,
  x,
  y,
  deleteEnabled,
  onPointerEnter,
  onPointerLeave,
  onPointerDown,
  onDragStart,
  onDragEnd,
  onDelete,
  draggable = true,
  ...props
}: Omit<ImageConfig, 'image'> &
  KonvaNodeEvents & {
    draggable?: boolean;
    imgSrc: string;
    x: number;
    y: number;
    deleteEnabled?: boolean;
    onDelete?: () => void;
  }) {
  const [image] = useImage(imgSrc);
  const [hovered, setHovered] = useState(false);
  const [dragging, setDragging] = useState(false);

  return (
    <>
      <Group
        draggable={draggable}
        x={x - 24}
        y={y - 24}
        onClick={(e) => {
          e.evt.stopImmediatePropagation();
        }}
        onDragStart={(e) => {
          setDragging(true);
          onDragStart?.(e);
        }}
        onDragEnd={(e) => {
          setDragging(false);
          onDragEnd?.(e);
        }}
        onPointerDown={onPointerDown}
        onPointerEnter={(e) => {
          setHovered(true);
          onPointerEnter?.(e);
        }}
        onPointerLeave={(e) => {
          setHovered(false);
          onPointerLeave?.(e);
        }}
      >
        <Rect
          width={48}
          height={48}
          cornerRadius={4}
          fill="white"
          shadowBlur={5}
          shadowOpacity={0.1}
          shadowOffsetY={5}
        ></Rect>
        <Image
          x={4}
          y={4}
          width={40}
          height={40}
          fit="contain"
          {...props}
          image={image}
        />
      </Group>
      {hovered && !dragging && deleteEnabled && (
        <Html
          groupProps={{
            x: x + 8,
            y: y - 34,
          }}
        >
          <Button
            size="1"
            className="w-6 p-0"
            color="red"
            radius="full"
            onClick={onDelete}
          >
            <TrashIcon />
          </Button>
        </Html>
      )}
    </>
  );
}
